module.exports = "/_next/static/images/ImplementationOptions-84c04f4f78fc59699042bbf8461718e4.webp";